import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_theme90wn9glxu60a as get_theme } from './Element.ext.mjs';
import {
  get_native16zxqjg6lrtlz as get_native,
  Job$cancel$ref2r8rkxbnqcz6i as Job$cancel$ref,
} from './NativeElement.commonHtml.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function animateOut(_this__u8e3s4, transition, done) {
  done = done === VOID ? null : done;
  var keyframeName = _this__u8e3s4.get_context_h02k06_k$().kiteUiCss_1.transition_pc86d7_k$(transition);
  var transitionTime = get_theme(_this__u8e3s4).transitionDuration_1;
  var easing = transition.easing_1;
  var easingCss = 'cubic-bezier(' + easing.x1__1 + ', ' + easing.y1__1 + ', ' + easing.x2__1 + ', ' + easing.y2__1 + ')';
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = get_native(_this__u8e3s4);
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
      return Unit_instance;
    });
  }
  if (done == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kiteui.afterTimeout' call
    var milliseconds = _Duration___get_inWholeMilliseconds__impl__msfiry(transitionTime);
    var job = launch(_this__u8e3s4, VOID, VOID, animateOut$slambda(milliseconds, done));
    Job$cancel$ref(job);
  }
}
function animateIn(_this__u8e3s4, transition, done) {
  done = done === VOID ? null : done;
  var keyframeName = _this__u8e3s4.get_context_h02k06_k$().kiteUiCss_1.transition_pc86d7_k$(transition);
  var transitionTime = get_theme(_this__u8e3s4).transitionDuration_1;
  var easing = transition.easing_1;
  var easingCss = 'cubic-bezier(' + easing.x1__1 + ', ' + easing.y1__1 + ', ' + easing.x2__1 + ', ' + easing.y2__1 + ')';
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = get_native(_this__u8e3s4);
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
      return Unit_instance;
    });
  }
  if (done == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kiteui.afterTimeout' call
    var milliseconds = _Duration___get_inWholeMilliseconds__impl__msfiry(transitionTime);
    var job = launch(_this__u8e3s4, VOID, VOID, animateIn$slambda(milliseconds, done));
    Job$cancel$ref(job);
  }
}
function animateOut$slambda($milliseconds, $action) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    $action();
    return Unit_instance;
  }), 1);
}
function animateIn$slambda($milliseconds, $action) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    $action();
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  animateIn as animateInmud32j2tnt7g,
  animateOut as animateOut2lmw712yu1fdk,
};
//endregion

//# sourceMappingURL=animations.js.mjs.map
